module.exports = __webpack_public_path__ + "assets/img/healthy-tag-back2.619fca0d.png";